import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { Link } from 'react-router-dom'
import blog3 from '../../images/blog-details/comments-author/img-1.jpg'
import blog4 from '../../images/blog-details/comments-author/img-2.jpg'
import BlogSidebar from '../BlogSidebar/BlogSidebar'

const BlogSingle = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const blogData = props.blogData || {};

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
    };

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        website: '',
        comment: '',
        insuranceb: false,
    });

    const [validator] = useState(new SimpleReactValidator());

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
        validator.showMessageFor(name);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setFormData({
                name: '',
                email: '',
                phone: '',
                website: '',
                comment: '',
                insuranceb: false,
            });
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };


    return (
        <section className={`blog-single-section section-padding ${props.blSclass}`}>
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            <div className="post format-standard-image">
                                <div className="entry-media">
                                    <img src={blogData.image_url || blogData.thumb_url || '/images/blog-details/img-1.jpg'} alt={blogData.title} />
                                </div>
                                <div className="entry-meta">
                                    <ul>
                                        <li><i className="fi flaticon-calendar"></i><Link onClick={ClickHandler} to="#">{formatDate(blogData.published_at || blogData.created_at)}</Link>
                                        </li>
                                        <li><i className="fi flaticon-comments"></i> <Link onClick={ClickHandler} to="#">Comments</Link></li>
                                        <li><i className="fi flaticon-clock"></i><Link onClick={ClickHandler} to="#">{blogData.read_time || '3 min Read'}</Link></li>
                                    </ul>
                                </div>
                                <div className="entry-details">
                                    <h3>{blogData.title}</h3>
                                    <p>{blogData.content || blogData.description}</p>
                                </div>
                            </div>
                            {blogData.quote && (
                                <blockquote>
                                    {blogData.quote}
                                    {blogData.quote_author && <span>{blogData.quote_author}</span>}
                                </blockquote>
                            )}
                            <div className="tag-share-wrap">
                                <div className="row">
                                    <div className="col-lg-6 col-12">
                                        <div className="tag-share clearfix">
                                            <div className="tag">
                                                <span>Tag: </span>
                                                <ul>
                                                    <li><Link onClick={ClickHandler} to="/blog">Community</Link></li>
                                                    <li><Link onClick={ClickHandler} to="/blog">Mosque</Link></li>
                                                    <li><Link onClick={ClickHandler} to="/blog">Events</Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-12">
                                        <div className="tag-share-s2 clearfix">
                                            <div className="tag">
                                                <span>Share: </span>
                                                <ul>
                                                    <li><Link onClick={ClickHandler} to="#"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                                                    <li><Link onClick={ClickHandler} to="#"><i className="flaticon-vimeo"></i></Link></li>
                                                    <li><Link onClick={ClickHandler} to="#"><i className="flaticon-linkedin"></i></Link></li>
                                                    <li><Link onClick={ClickHandler} to="#"><i className="flaticon-twitter"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="more-posts">
                                <div className="previous-post">
                                    <Link to="/blog">
                                        <span className="post-control-link">Previous Post</span>
                                        <span className="post-name">Back to Blog</span>
                                    </Link>
                                </div>
                                <div className="next-post">
                                    <Link to="/blog">
                                        <span className="post-control-link">Next Post</span>
                                        <span className="post-name">View All Posts</span>
                                    </Link>
                                </div>
                            </div>
                            <div className="comments-area">
                                <div className="comments-section">
                                    <h3 className="comments-title">Comments</h3>
                                    <ol className="comments">
                                        <li className="comment even thread-even depth-1" id="comment-1">
                                            <div id="div-comment-1">
                                                <div className="comment-theme">
                                                    <div className="comment-image"><img
                                                        src={blog3} alt='' />
                                                    </div>
                                                </div>
                                                <div className="comment-main-area">
                                                    <div className="comment-wrapper">
                                                        <div className="comments-meta">
                                                            <h4>Community Member <span className="comments-date">
                                                                Recently</span></h4>
                                                        </div>
                                                        <div className="comment-area">
                                                            <p>
                                                                JazakAllah Khair for sharing this wonderful content with our community.
                                                                May Allah bless your efforts in spreading knowledge and bringing our
                                                                community together.
                                                            </p>
                                                            <div className="comments-reply">
                                                                <Link onClick={ClickHandler} className="comment-reply-link" to="#"><i
                                                                    className="flaticon-back"></i></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="children">
                                                <li className="comment">
                                                    <div>
                                                        <div className="comment-theme">
                                                            <div className="comment-image"><img
                                                                src={blog4}
                                                                alt='' /></div>
                                                        </div>
                                                        <div className="comment-main-area">
                                                            <div className="comment-wrapper">
                                                                <div className="comments-meta">
                                                                    <h4>PCIC Team<span className="comments-date">
                                                                        Recently
                                                                    </span></h4>
                                                                </div>
                                                                <div className="comment-area">
                                                                    <p>Wa iyyakum! Thank you for your kind words and support.
                                                                        We are grateful to have such an engaged community.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ol>
                                </div>
                                <div className="comment-respond">
                                    <h3 className="comment-reply-title">Post Comments</h3>
                                    <form id="commentForm" className="comment-form" onSubmit={handleSubmit}>
                                        <div className="form-inputs">
                                            <div>
                                                <input
                                                    id="name"
                                                    name="name"
                                                    placeholder="Enter your name*"
                                                    type="text"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                {validator.message('name', formData.name, 'required|alpha')}
                                            </div>
                                            <div>
                                                <input
                                                    id="email"
                                                    name="email"
                                                    placeholder="Enter your mail*"
                                                    type="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                {validator.message('email', formData.email, 'required|email')}

                                            </div>
                                            <div>
                                                <input
                                                    id="phone"
                                                    name="phone"
                                                    placeholder="Enter your number*"
                                                    type="text"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                {validator.message('phone', formData.phone, 'required|phone')}
                                            </div>
                                            <div>
                                                <input
                                                    id="website"
                                                    name="website"
                                                    placeholder="Website*"
                                                    type="url"
                                                    value={formData.website}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                {validator.message('website', formData.website, 'required|url')}
                                            </div>
                                        </div>
                                        <div className="form-textarea">
                                            <textarea
                                                id="comment"
                                                name="comment"
                                                placeholder="Enter your Message*"
                                                value={formData.comment}
                                                onChange={handleChange}
                                                required
                                            ></textarea>
                                            {validator.message('comment', formData.comment, 'required')}
                                        </div>
                                        <div className="terms">
                                            <input
                                                className="checkbox"
                                                type="checkbox"
                                                id="insuranceb"
                                                name="insuranceb"
                                                checked={formData.insuranceb}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="insuranceb">Save my name, email, and website in this browser for the next time I comment.</label>
                                        </div>
                                        <div className="form-submit">
                                            <input className="theme-btn" id="submit" value="Send Message" type="submit" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <BlogSidebar blLeft={props.blLeft} />
                </div>
            </div>
        </section>
    )

}

export default BlogSingle;
